module.exports = __webpack_public_path__ + "static/media/agencies.045e6d98.svg";